import { useSelector } from 'react-redux';

/**
 * Hook to get Viaja Ahorrando discount percentage from purchase tickets.
 * Gets discount_percent from the first ticket with viva_trip_discount.
 * @returns {number|null} Discount percentage or null if not found
 */
const useViajaAhorrandoDiscountPercent = () => {
  const discountPercent = useSelector((state) => {
    const { purchase } = state;
    if (!purchase) return null;

    // Get tickets from departs and returns
    const departsTickets = purchase.getIn(['departs', 'fragments'])?.toJS()?.[0]?.tickets || [];
    const returnsTickets = purchase.getIn(['returns', 'fragments'])?.toJS()?.[0]?.tickets || [];
    const allTickets = [...departsTickets, ...returnsTickets];

    // Find first ticket with viva_trip_discount
    const vivaTicket = allTickets.find((ticket) => ticket.discountType === 'viva_trip_discount');

    return vivaTicket?.discountPercent || null;
  });

  return discountPercent;
};

export default useViajaAhorrandoDiscountPercent;
